module.exports = __webpack_public_path__ + "static/media/mandala.0f37de35.JPG";